import axios from 'axios';
import history from "./history";
import { apiUrl } from "./constants";
class Request {
  // Initialize axios
  init = () => {
    return axios.create({
      baseURL: apiUrl(),
      timeout: 15000,
      headers: {
        "X-Requested-With": "xmlhttprequest",
        "Authorization": "Bearer " + this.getCookie('accessToken')
      }
    });
  };
  initXML = () => {
    return axios.create({
      timeout: 15000,
      headers: {
        "Content-Type": "application/xml; charset=utf-8"
      }
    });
  }
  // axios get method definition
  get = (cls, endpoint, payload, handler = false) => {
    let self = this;
    let instance = this.init();
    if (endpoint.indexOf('api:') > -1) {
      endpoint = endpoint.replace('api:', apiUrl());
    }
    instance.defaults.responseType = "json";
    let callback = handler;
    let params = '';
    if (payload) params = '?payload=' + JSON.stringify(payload);
    return instance
      .get(endpoint + params)
      .then(response => {
        const isResult = response.data && Object.keys(response.data).length;
        if (!isResult) throw new Error("No response data");
        return isResult ? response.data : [];
      })
      .catch(error => {
        return self.handleError(error);
      })
      .then(response => {
        if (callback) callback(response);
        return response;
      });
  };
  //axios post method definition
  post = (cls, endpoint, payload, handler = false) => {
    let self = this;
    let instance = this.init();
    if (endpoint.indexOf('api:') > -1) {
      endpoint = endpoint.replace('api:', apiUrl());
    }
    instance.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
    instance.defaults.responseType = "json";
    let callback = handler;
    return instance
      .post(endpoint, payload)
      .then(response => {
        const isResult = response.data && Object.keys(response.data).length;
        if (!isResult) throw new Error("No response data");
        return isResult ? response.data : [];
      })
      .catch(error => {
        return self.handleError(error);
      })
      .then(response => {
        if (callback) callback(response);
        return response;
      });
  };
  //axios put method definition
  put = (cls, endpoint, payload, handler = false) => {
    let self = this;
    let instance = this.init();
    if (endpoint.indexOf('api:') > -1) {
      endpoint = endpoint.replace('api:', apiUrl());
    }
    instance.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
    instance.defaults.responseType = "json";
    let callback = handler;
    return instance
      .put(endpoint, payload)
      .then(response => {
        const isResult = response.data && Object.keys(response.data).length;
        if (!isResult) throw new Error("No response data");
        return isResult ? response.data : [];
      })
      .catch(error => {
        return self.handleError(error);
      })
      .then(response => {
        if (callback) callback(response);
        return response;
      });
  };
  // axios delete method definition
  delete = (cls, endpoint, payload, handler = false) => {
    let self = this;
    let instance = this.init();
    if (endpoint.indexOf('api:') > -1) {
      endpoint = endpoint.replace('api:', apiUrl());
    }
    instance.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
    instance.defaults.responseType = "json";
    let callback = handler;
    return instance
      .delete(endpoint, payload)
      .then(response => {
        const isResult = response.data && Object.keys(response.data).length;
        if (!isResult) throw new Error("No response data");
        return isResult ? response.data : [];
      })
      .catch(error => {
        return self.handleError(error);
      })
      .then(response => {
        if (callback) callback(response);
        return response;
      });
  };
  // axios download method definition
  download = (cls, endpoint, payload) => {
    let self = this;
    let instance = this.init();
    if (endpoint.indexOf('api:') > -1) {
      endpoint = endpoint.replace('api:', apiUrl());
    }
    instance.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
    instance.defaults.responseType = "blob";
    return instance
      .post(endpoint, payload)
      .then(response => {
        let blob = new Blob([response.data], {
          type: response.headers["content-type"]
        }),
          xlsUrl = window.URL.createObjectURL(blob),
          tempLink = document.createElement("a");
        tempLink.href = xlsUrl;
        tempLink.setAttribute("download", "report.csv");
        setTimeout(() => tempLink.click(), 500);
        cls.setState({ isLoading: false });
      })
      .catch(error => {
        self.handleError(error);
      });
  };
  getDownload = (cls, endpoint, payload) => {
    let self = this;
    let instance = this.init();
    if (endpoint.indexOf('api:') > -1) {
      endpoint = endpoint.replace('api:', apiUrl());
    }
    instance.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
    instance.defaults.responseType = "blob";
    let params = '';
    if (payload) params = '?payload=' + JSON.stringify(payload);
    return instance
      .get(endpoint + params)
      .then(response => {
        let blob = new Blob([response.data], {
          type: response.headers["content-type"]
        }),
          xlsUrl = window.URL.createObjectURL(blob),
          tempLink = document.createElement("a");
        tempLink.href = xlsUrl;
        setTimeout(() => tempLink.click(), 500);
        cls.setState({ isLoading: false });
      })
      .catch(error => {
        self.handleError(error);
      });
  };
  getQrCode = (cls, endpoint, payload) => {
    let self = this;
    let instance = this.init();
    if (endpoint.indexOf('api:') > -1) {
      endpoint = endpoint.replace('api:', apiUrl());
    }
    instance.defaults.headers.post["Content-Type"] =
      "application/x-www-form-urlencoded";
    instance.defaults.responseType = "blob";
    return instance
      .post(endpoint, payload, {responseType: 'blob'})
      .then(response => {
        return URL.createObjectURL(response.data)
      })
      .catch(error => {
        self.handleError(error);
      });
  };
  // axios get XML Feed definition
  getXML = (cls, endpoint) => {
    let self = this;
    let instance = this.initXML();
    let xmlToJsonData;
    var parseString = require('xml2js').parseString;
    return instance
      .get(endpoint, {responseType: 'text'})
      .then(response => {
        var xml = response && response.data;
        parseString(xml, function (err, result) {
          xmlToJsonData = result;
        });
        if (!xml) throw new Error("No response data");
        return xmlToJsonData ? xmlToJsonData : [];
      })
      .catch(error => {
        return self.handleError(error);
      })
  };
  handleError = error => {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      let msg = "";
      if (error.response.data.message) {
        msg = error.response.data.message;
      } else {
        msg = error.message
      }
      // Handle 400 errors
      if (error.response.status === 400) {
        return {
          status: "error",
          message: msg ? msg : "Bad Request error"
        }; 
      };
      // Handle 500 errors
      if (error.response.status === 500) {
        return {
          status: "error",
          message: msg ? msg : "Server error"
        }; 
      };
      // Handle 401 errors
      if (error.response.status === 401) {
        history.push(history.location.pathname);
      };
      return error.response.data;
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      return {
        status: "error",
        message: error.request.statusText
          ? error.request.statusText
          : "Request error"
      };
    } else {
      // Something happened in setting up the request that triggered an Error
      return {
        status: "error",
        message: error.message ? error.message : "Request setup error"
      };
    }
  };
  getCookie = name => {
    var value = "; " + document.cookie;
    var parts = value.split("; " + name + "=");
    if (parts.length === 2)
      return parts
        .pop()
        .split(";")
        .shift();
  };
}

export default new Request();
